module.exports = __webpack_public_path__ + "img/logo-01.cff9e1d7.svg";